/**
 * BugStateEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { BugWorkflowEntity } from "../BugWorkflowEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { BugTransitionEntity } from "../BugTransitionEntity";
import { VisitTypeEntity } from "../VisitTypeEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { BugStateEntity } from "../BugStateEntity";
declare global {
    interface EntityTypeMap {
        BugState: BugStateEntity;
    }
}
export abstract class BugStateGeneratedEntity extends BaseEntity {
    public abstract bugStateId: string;
    public abstract templateName: string | null;
    public abstract templateId: string | null;
    public abstract equivBugState: number;
    public abstract color: number | null;
    public abstract name: string;
    public abstract orderHint: number;
    public abstract enterAction: number;
    public abstract bugWorkflow: BugWorkflowEntity;
    public abstract bugGroup: BugGroupEntity | null;
    public abstract readonly bugTransitionStarts: ReadonlyArray<BugTransitionEntity>;
    public abstract readonly bugTransitionEnds: ReadonlyArray<BugTransitionEntity>;
    public abstract readonly visitTypes: ReadonlyArray<VisitTypeEntity>;
    public abstract readonly bugNotes: ReadonlyArray<BugNoteEntity>;
}
